module.exports = __webpack_public_path__ + "img/_video_on.5f6af2ac.svg";